/**
 * Automotive panel widgets — ambient.
 */
import { registerAutomotive } from '../../registryCore';
import { str } from '../../helpers';
import { addPanelFrame, addPanelTitle, finishPanel, panelBounds, panelGroup, panelTheme, textAt, } from '../panelPrimitives';
import { fluidFont } from '../../layout';
import { lines } from './shared';
registerAutomotive('sunriseSunset', function (props, app) {
    var _a, _b, _c, _d;
    var theme = panelTheme(props);
    var bounds = panelBounds(props, 180, 100);
    var group = panelGroup(app, 'sunriseSunset', props, bounds);
    var pad = bounds.pad, w = bounds.innerWidth, h = bounds.innerHeight;
    var rowLines = lines(props, ['Rise 06:12', 'Set 19:45']);
    var sunrise = str(props, 'sunrise', (_b = (_a = rowLines[0]) === null || _a === void 0 ? void 0 : _a.replace(/^Rise\s*/, '')) !== null && _b !== void 0 ? _b : '06:12');
    var sunset = str(props, 'sunset', (_d = (_c = rowLines[1]) === null || _c === void 0 ? void 0 : _c.replace(/^Set\s*/, '')) !== null && _d !== void 0 ? _d : '19:45');
    addPanelFrame(group, app, bounds, theme);
    var top = addPanelTitle(group, app, bounds, theme, 'Sun');
    var horizonY = top + (pad + h - top) * 0.42;
    group.add(app.line({
        x: pad + 6,
        y: horizonY,
        x2: w - 12,
        y2: 0,
        stroke: theme.dialStroke,
        strokeWidth: 1,
        listening: false,
    }), app.path({
        d: "M ".concat(pad + 6, " ").concat(horizonY, " Q ").concat(pad + w / 2, " ").concat(top + 8, " ").concat(pad + w - 6, " ").concat(horizonY),
        stroke: 'rgba(251,191,36,0.25)',
        strokeWidth: 1,
        listening: false,
    }));
    var sunX = pad + w * 0.68;
    group.add(app.circle({
        x: sunX - 9,
        y: horizonY - 18,
        radius: 9,
        fill: '#fbbf24',
        opacity: 0.95,
        listening: false,
    }));
    group.add(app.text({
        text: "\u2191 ".concat(sunrise),
        x: pad + 4,
        y: textAt(pad + h - 10, 10),
        fontSize: fluidFont(10, bounds, 8, 11),
        fill: theme.text,
        listening: false,
    }), app.text({
        text: "\u2193 ".concat(sunset),
        x: pad + w - 48,
        y: textAt(pad + h - 10, 10),
        fontSize: fluidFont(10, bounds, 8, 11),
        fill: theme.textMuted,
        listening: false,
    }));
    return finishPanel(group, props, bounds, { sunrise: sunrise, sunset: sunset });
});
